import { ErrorLayout } from "common/components/ErrorLayout"

const Custom404 = () => {
  return (
    <ErrorLayout>
      <div className="px-2 pb-8 text-center text-lg">
        Even our brightest academic minds couldn&apos;t find this page. Return{" "}
        <a className="underline" href="https://theconversation.com">
          home
        </a>{" "}
        or{" "}
        <a className="underline" href="https://theconversation.com/search">
          search
        </a>{" "}
        for answers.
      </div>
      <div className="px-2 pb-8 text-center text-lg">
        Ni siquiera nuestras mentes académicas más brillantes han podido encontrar esta página.
        Vuelva{" "}
        <a className="underline" href="https://theconversation.com">
          página de inicio
        </a>{" "}
        o{" "}
        <a className="underline" href="https://theconversation.com/search">
          busque
        </a>{" "}
        las respuestas.
      </div>
      <div className="px-2 pb-8 text-center text-lg">
        Même nos plus brillants esprits académiques n&apos;ont pas pu trouver cette page. Retournez
        à la{" "}
        <a className="underline" href="https://theconversation.com">
          page d&apos;accueil
        </a>{" "}
        ou{" "}
        <a className="underline" href="https://theconversation.com/search">
          cherchez
        </a>{" "}
        des réponses.
      </div>
      <div className="px-2 pb-8 text-center text-lg">
        Bahkan para akademisi terpintar kami tidak dapat menemukan halaman ini. Kembali ke{" "}
        <a className="underline" href="https://theconversation.com">
          rumah
        </a>{" "}
        atau{" "}
        <a className="underline" href="https://theconversation.com/search">
          cari
        </a>{" "}
        jawaban.
      </div>
      <div className="px-2 pb-8 text-center text-lg">
        Mesmo nossas mentes acadêmicas mais brilhantes não conseguiram encontrar esta página.
        Retornar a{" "}
        <a className="underline" href="https://theconversation.com">
          página inicial
        </a>{" "}
        ou{" "}
        <a className="underline" href="https://theconversation.com/search">
          procure
        </a>{" "}
        por respostas.
      </div>
      <div className="px-2 pb-8 text-center text-lg">
        Selbst unsere brillantesten akademischen Köpfe konnten diese Seite nicht finden. Kehren Sie
        zur{" "}
        <a className="underline" href="https://theconversation.com">
          Startseite
        </a>{" "}
        zurück oder{" "}
        <a className="underline" href="https://theconversation.com/search">
          suchen
        </a>{" "}
        Sie nach Antworten.
      </div>
      <div className="px-2 pb-8 text-center text-lg">
        Ni tan sols les nostres ments acadèmiques més brillants han pogut trobar aquesta pàgina.
        Torna a la nostra{" "}
        <a className="underline" href="https://theconversation.com">
          pàgina d&apos;inici
        </a>{" "}
        o{" "}
        <a className="underline" href="https://theconversation.com/search">
          busca
        </a>{" "}
        respostes.
      </div>
    </ErrorLayout>
  )
}

export default Custom404
